<template>
  <div class="card mb-3">
    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
      <h6 class="m-0 font-weight-bold text-primary">Helper Information</h6>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="form-group col-6 mb-2">
          <skeleton-box
            height="30px"
            width="100%"
            v-show="is_loading"/>
          <div v-show="!is_loading">
            <label for="#form-education" class="pl-0 m-0 d-flex align-items-center">Name</label>
            <input type="text" disabled class="form-control" id="form-reference_by" v-model="data.helper.name">
          </div>
        </div>
        <div class="form-group col-6 mb-2">
          <skeleton-box
            height="30px"
            width="100%"
            v-show="is_loading"/>
          <div v-show="!is_loading">
            <label for="#form-education" class="pl-0 m-0 d-flex align-items-center">Email</label>
            <input type="text" disabled class="form-control" id="form-reference_by" v-model="data.helper.email">
          </div>
        </div>
        <div class="form-group col-6 mb-2">
          <skeleton-box
            height="30px"
            width="100%"
            v-show="is_loading"/>
          <div v-show="!is_loading">
            <label for="#form-education" class="pl-0 m-0 d-flex align-items-center">Phone Number</label>
            <input type="text" disabled class="form-control" id="form-reference_by" v-model="data.helper.phone">
          </div>
        </div>
        <div class="form-group col-6 mb-2">
          <skeleton-box
            height="30px"
            width="100%"
            v-show="is_loading"/>
          <div v-show="!is_loading">
            <label for="#form-education" class="pl-0 m-0 d-flex align-items-center">Address</label>
            <input type="text" disabled class="form-control" id="form-reference_by" v-model="data.helper.address">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SkeletonBox from '@/layout/skeleton'

export default {
  props: ['data', 'is_loading'],
  components:{
    'skeleton-box': SkeletonBox,
  },
}
</script>
